export default class RedirectUrls {

    //Teams app for join
    public static readonly teamsAppForJoin: string = "msteams:";

    //Join for browser
    public static readonly browserForJoin: string = "https://teams.cloud.microsoft";
}